import { Controller } from "@hotwired/stimulus"

// STEP-Export der 3D-Szene: Szenen-JSON laden, im Web Worker
// (step_worker.js, replicad/OpenCascade) in STEP wandeln und als
// <projektname>.step herunterladen.
export default class extends Controller {
  static values = { sceneUrl: String, workerUrl: String, filename: String }

  disconnect() {
    this.worker?.terminate()
    this.worker = null
  }

  async export(event) {
    const button = event.currentTarget
    if (button.disabled) return

    const label = button.textContent
    button.disabled = true
    button.textContent = "Exportiere…"

    try {
      const response = await fetch(this.sceneUrlValue, { headers: { Accept: "application/json" } })
      if (!response.ok) throw new Error(`Szene konnte nicht geladen werden (HTTP ${response.status})`)
      const scene = await response.json()

      const { buffer, skipped } = await this.runWorker(scene.parts || [], (done, total) => {
        button.textContent = `Exportiere… ${done}/${total}`
      })
      this.download(new Blob([buffer], { type: "application/step" }))
      if (skipped > 0) {
        alert(`STEP-Export fertig, aber ${skipped} Bearbeitung(en) ließen sich nicht bauen ` +
          "und fehlen in der Datei. Die betroffenen Teile sind sonst vollständig enthalten.")
      }
    } catch (error) {
      alert(`STEP-Export fehlgeschlagen: ${error?.message || error}`)
    } finally {
      button.disabled = false
      button.textContent = label
    }
  }

  runWorker(parts, onProgress) {
    return new Promise((resolve, reject) => {
      this.worker ||= new Worker(this.workerUrlValue, { type: "module" })
      this.worker.onmessage = (event) => {
        if (typeof event.data.progress === "number") {
          onProgress(event.data.progress, event.data.total)
        } else if (event.data.ok) {
          resolve({ buffer: event.data.buffer, skipped: event.data.skipped || 0 })
        } else {
          reject(new Error(event.data.error))
        }
      }
      this.worker.onerror = () => reject(new Error("Worker konnte nicht geladen werden"))
      this.worker.postMessage({ parts })
    })
  }

  download(blob) {
    const name = (this.filenameValue || "export").replace(/[/\\]/g, "-")
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = `${name}.step`
    link.click()
    URL.revokeObjectURL(url)
  }
}
